<iframe *ngIf="url && isGrafanaSessionPresent" [src]="url + timeRangeToAppendEvent + reloadEvent |safe" width="100%" style="min-height:300px"  height="98%"
  frameborder="0" ></iframe>
<div *ngIf="!url || !isGrafanaSessionPresent" id="container">
  <div id="content">
    <h3 *ngIf="!isGraphLoading">{{switchState}} is unavailable...</h3>
    <i class="fa fa-spinner fa-spin" *ngIf="isGraphLoading" style="font-size:36px;"></i>
  </div>
</div>